export default __webpack_public_path__ + "static/media/AcceptIcon.684bf43b.svg";